<script>
    import {onMount, onDestroy} from 'svelte';
    import {browser} from '$app/environment';

    import {categories_all, categories, start_date, end_date, do_load_layout} from '$lib/store.js';

    import HeaderApp from '$lib/header/Header-app.svelte';
    import DocMenu from './DocMenu.svelte';
    import CallToAction from '$lib/CallToAction.svelte';

    // Initialize $categories and set them all to false (i.e. unchecked)
    if ($do_load_layout) {
        $categories_all.forEach(category => {
            $categories[category['key']] = false;
        });
    }

    // Clear dates
    if ($do_load_layout) {
        $start_date = null;
        $end_date = null;
    } else {
        $do_load_layout = true;
    }

    onMount(() => {
        document.body.classList.add('page-feed');
    });

    onDestroy(() => {
        if (browser) {
            document.body.classList.remove('page-feed');
        }
    });
</script>

<HeaderApp/>

<main>
    <section class="container">
        <div class="row">
            <div class="col-12">
                <DocMenu/>
            </div>
        </div>
    </section>

    <section id="monitor">
        <div class="container">
            <div class="row">
                <slot></slot>
            </div>
        </div>
    </section>

    <CallToAction/>
</main>

<style lang="scss">
    :global(.page-feed) {
        overflow-y: scroll; /* Show vertical scrollbar */
    }

    :global(.selected>a) {
        font-weight: bold;
        border: 1px solid var(--light-blue-color4) !important;
        border-radius: 15px;
        background-color: var(--light-blue-color5) !important;
    }

    #monitor {
        background-color: var(--light-blue-color);
        border-top: 1px solid var(--light-blue-color5);
        padding-top: 26px;
        padding-bottom: 53px;
    }

    :global(.row.checkboxes) {
        padding-left: 17px;
    }

    :global(.checkboxes) {
        :global(h3), :global(h5) {
            font-family: var(--font-amaranth);
            font-size: 20px !important;
            line-height: 20.8px !important;
            margin-bottom: 0 !important;
        }

        :global(>ul), :global(>div>ul) {
            margin-bottom: 28px;
            padding-left: 0 !important;
            list-style-type: none;

            :global(li) {
                list-style-type: none;
            }

            :global(input) {
                list-style-type: none;
                margin-top: 20px;
                margin-right: 14px;
            }

            :global(label) {
                display: inline;
                color: var(--dark-blue-color);
            }
        }
    }
</style>
